import React from 'react';
import PricingCards from '../components/PricingCards';
import Button from '../components/Button';
import PricingFAQ from '../components/PricingFAQ';

const Pricing = () => {
  return (
    <div className="min-h-screen pt-24 pb-16 px-4 bg-dark">
      <div className="max-w-7xl mx-auto">
        {/* Header Section */}
        <div className="text-center mb-12">
          <h1 className="text-4xl md:text-5xl font-bold text-light mb-6">Transparent Pricing Options</h1>
          <p className="text-xl text-light/80 max-w-3xl mx-auto">
            Choose the engagement model that best fits your organization's needs and objectives.
            All options provide access to my expertise in strategic planning, AI implementation, 
            and digital transformation.
          </p>
        </div>
        
        {/* Pricing Cards */}
        <PricingCards />
        
        {/* Custom Projects Section */}
        <div className="mt-16 text-center p-8 border border-light/10 rounded-xl bg-dark/50 backdrop-blur-sm">
          <h2 className="text-2xl md:text-3xl font-bold text-light mb-4">
            Need a Custom Solution?
          </h2>
          <p className="text-light/80 text-lg max-w-3xl mx-auto mb-6">
            For complex projects or specialized requirements, I offer tailored consulting packages 
            designed specifically for your organization's unique challenges and goals.
          </p>
          <Button 
            primary
            onClick={() => window.location.href = '/contact'}
          >
            Contact for Custom Pricing
          </Button>
        </div>
        
        {/* FAQs Section */}
        <PricingFAQ />
      </div>
    </div>
  );
};

export default Pricing;
